import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=5d71450a"
import script from "./PreFooter.vue?vue&type=script&lang=js"
export * from "./PreFooter.vue?vue&type=script&lang=js"
import style0 from "./PreFooter.vue?vue&type=style&index=0&id=5d71450a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports